module.exports = __webpack_public_path__ + "static/img/アセット 82@3x.f99d1f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 82@3x.png
// module id = 3Smq
// module chunks = 1